import * as Yup from "yup";

// Define validation schema
const alertValidationSchema = Yup.object().shape({
  date: Yup.string().required("Date is required"),
  time: Yup.string().required("Time is required"),
  alert: Yup.string().nullable().required("Alert selection is required"),
  camera: Yup.string().nullable().required("Camera selection is required"),
  status: Yup.string().nullable().required("Status selection is required"),
  location: Yup.string().nullable().required("Location selection is required"),
  alertsAssignedMails: Yup.array().min(
    1,
    "At least one assigned email is required"
  ),
  esscalationEmails: Yup.array().min(
    1,
    "At least one escalation email is required"
  ),
  image: Yup.string().nullable().required("Image is required"),
  // image: Yup.array().min(1, "Only single image is required"),
});

export default alertValidationSchema;
